import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import ProductSection from "@/components/ProductSection";
import ToteDefender from "@/components/ToteDefender";
import SocialFeed from "@/components/SocialFeed";
import Faq from "@/components/Faq";
import Reviews from "@/components/Reviews";
import VideoSection from "@/components/VideoSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import PaymentSuccess from "@/components/PaymentSuccess";
import PaymentCancel from "@/components/PaymentCancel";
import VisitorTracker from "@/components/VisitorTracker";
import SalesAssistant from "@/components/SalesAssistant";
import HesitationRescuer from "@/components/HesitationRescuer";
import CRM from "@/pages/CRM";
import Community from "@/pages/Community";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Review from "@/pages/Review";

function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -64, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-white text-[#17150f] min-h-screen" data-testid="noxway-page">
      <Nav />
      <main>
        <Hero />
        <Features />
        <ProductSection />
        <ToteDefender />
        <SocialFeed />
        <Faq />
        <Reviews />
        <VideoSection />
        <FinalCTA />
      </main>
      <Footer />
      <VisitorTracker />
      <SalesAssistant />
      <HesitationRescuer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/crm" element={<CRM />} />
        <Route path="/community" element={<Community />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/review" element={<Review />} />
      </Routes>
    </BrowserRouter>
  );
}
